import { ReactNode } from "react";
import { Layout } from "@/components/layout";

interface DashboardShellProps {
  children: ReactNode;
}

export function DashboardShell({ children }: DashboardShellProps) {
  return <Layout>{children}</Layout>;
}